import React, { Component } from 'react';
import { findDOMNode } from 'react-dom'
import { Route, Switch, withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { dispatch } from '@rematch/core';
import SplitPane from "react-split-pane";
import '@zippytech/react-toolkit/SplitContainer/index.css'
import Dock from 'react-dock';
import { toastr } from 'react-redux-toastr';
import { Icon, Card, Image } from 'semantic-ui-react';
import comingsoonlogo from './../../images/common/coming-soon-logo.png'
import { AppHeader } from "./header";
import Workspace from "../workspace";
import Platform from "../platform";
import Account from '../account';
import { NoWorkspace } from "../noworkspace";
import HelpPane from './pane/HelpPane'
import SettingPane from './pane/SettingPane'
import NotificationPane from './pane/Notification'
import UserComment from './pane/Comment'
import Storage from './pane/Storage'
import NotFound from '../common/NotFound';
import UnAuthorized from '../common/UnAuthorized';
import Draggable from 'react-draggable';
import ReactPlayer from 'react-player'
import screenfull from 'screenfull'

class Home extends Component {

    constructor(props) {
        super(props);
        this.state = {
            isHelpVisible: false,
            isConfigVisible: false,
            width: false,
            accountNotificationCount: null
        };
    }

    handleHelpVisibleChange = async (isHelpVisible) => {
        // this.setState({ isHelpVisible: isHelpVisible });
        // await dispatch.app.setHelpContentData();
        let message = <div className="confirmMessage">
                    <h3>Visit Aspenify Support</h3>
                    <p>You are about to leave Aspenify to visit the Aspenify website.</p>
                    <p>Would you like to continue?</p>
                </div>
                toastr.confirm(message, {
                    onOk: async () => {
                         window.open("https://aspenify.com/about/contact-us/", "_blank", "noopener,noreferrer");
                    }
                });
    }   

    handleConfigVisibleChange = isConfigVisible => {
        this.setState({ isConfigVisible });
    }

    handleNotificationChange = async isNotificationVisible => {
        await dispatch.notifications.setFilterQueryData({});
        await dispatch.notifications.getNotifications({ accountId: this.props.selectedAccount._id, limit: 25 });
        await dispatch.notifications.markAllAsRead({ accountId: this.props.selectedAccount._id });
        await dispatch.notifications.accountNotificationsCount({ accountId: this.props.selectedAccount._id, organizationId: this.props.selectedOrganisation.id })
        //dispatch.notifications.seenNotificationAsync(this.props.allNotification)
        this.setState({ isNotificationVisible, accountNotificationCount: this.props.notificationsCount });
    }

    handleInboxVisibleChange = isInboxVisible => {
        this.setState({ isInboxVisible });
    }
    handleStorageVisibleChange = isStorageVisible => {
        this.setState({ isStorageVisible });
    }

    async componentDidMount() {
        dispatch.profile.modalOpen(false);
        dispatch.app.setAccountSubscriptionDetails(this.props.selectedAccount._id)

    }

    async componentDidUpdate(){
        if(this.props.selectedAccount && this.props.selectedAccount._id){
            dispatch.app.setAccountSubscriptionDetails(this.props.selectedAccount._id)
        }
    }

    closePlayer() {
        dispatch.help.setVideoDetails(null)
    }

    handleClickFullscreen = () => {
        screenfull.request(findDOMNode(this.player))
    }

    changeWidth = () => {
        this.setState({ width: !this.state.width })
    }

    ref = player => {
        this.player = player
    }

    render() {

        const {
            user,
            selectedOrganisation,
            selectedAccount,
            accessToken,
            organizations,
            helpContent,
            filterQuery
        } = this.props;

        const div = document.querySelector('div');
        div.hasAttribute('style');
        return (
            <div >
                <div className="dockDrawer">
                    <Dock position="right"
                        zIndex={999}
                        size={0.35}
                        dimMode='opaque'
                        isVisible={this.state.isHelpVisible}
                        onVisibleChange={this.handleHelpVisibleChange}
                        isResizing={false}
                        dimStyle={{ cursor: "pointer" }}

                    >
                        <HelpPane helpContent={helpContent} handleHelpVisibleChange={this.handleHelpVisibleChange} version={this.props.version} />
                    </Dock>

                    <Dock position="right"
                        zIndex={999}
                        size={0.35}
                        dimMode='opaque'
                        isVisible={this.state.isConfigVisible}
                        onVisibleChange={this.handleConfigVisibleChange}
                        isResizing={false}
                    >
                        <SettingPane handleConfigVisibleChange={this.handleConfigVisibleChange} orgData={this.props.selectedOrganisation} jwtToken={accessToken} user={user} />

                    </Dock>
                    <Dock position="right"
                        zIndex={999}
                        size={0.35}
                        dimMode='opaque'
                        isVisible={this.state.isNotificationVisible ? true : false}
                        onVisibleChange={this.handleNotificationChange}
                        isResizing={false}
                    >
                        <NotificationPane
                            handleNotificationChange={this.handleNotificationChange}
                            allNotification={this.props.allNotification}
                            loadingNotifications={this.props.loadingNotifications}
                            notificationsCount={this.state.accountNotificationCount}
                            selectedAccount={selectedAccount}
                            selectedOrganisation={selectedOrganisation}
                            filterQuery={filterQuery}
                        />
                    </Dock>

                    <Dock position="right"
                        zIndex={999}
                        size={0.35}
                        dimMode='opaque'
                        isVisible={this.state.isInboxVisible}
                        onVisibleChange={this.handleInboxVisibleChange}
                        isResizing={false}
                    >
                        <UserComment handleInboxVisibleChange={this.handleInboxVisibleChange} jwtToken={accessToken} user={user} />

                    </Dock>
                    <Dock position="right"
                        zIndex={999}
                        size={0.35}
                        dimMode='opaque'
                        isVisible={this.state.isStorageVisible}
                        onVisibleChange={this.handleStorageVisibleChange}
                        isResizing={false}
                    >
                        {window.location.hostname === "localhost" ?
                            <Storage handleStorageVisibleChange={this.handleStorageVisibleChange} user={this.props.user} selectedAccount={selectedAccount} organizations={organizations} />
                            : null
                        }

                    </Dock>
                </div>
                <SplitPane defaultSize="50px" split="horizontal" allowResize={false} style={{ left: "0px" }}>
                    <div style={{ width: "100%", zIndex: '99' }}>
                        <AppHeader
                            handleNotificationChange={this.handleNotificationChange}
                            handleInboxVisibleChange={this.handleInboxVisibleChange}
                            handleStorageVisibleChange={this.handleStorageVisibleChange}
                        />
                    </div>
                    <Switch>
                        <Route path="/app/platform" render={() =>
                            <Platform
                                handleConfigVisibleChange={this.handleConfigVisibleChange}
                                handleHelpVisibleChange={this.handleHelpVisibleChange}
                                user={user} />
                        } />
                        <Route path="/app/noworkspace" render={() =>
                            <NoWorkspace />
                        } />
                        <Route path="/app/:accountId/_ws/:workspaceId" render={() =>
                            <Workspace
                                handleConfigVisibleChange={this.handleConfigVisibleChange}
                                handleHelpVisibleChange={this.handleHelpVisibleChange}
                                selectedOrganisation={selectedOrganisation}
                                selectedAccount={selectedAccount}
                                user={user}
                                playbookPath={this.props.playbookPath}
                                contentPath={this.props.contentPath}
                                userCache={this.props.userCache}
                            />
                        } />
                        <Route path="/app/:accountId/404" component={NotFound} />
                        <Route path="/app/:accountId/print/abc" component={NotFound} />
                        <Route path="/app/:accountId/403" component={UnAuthorized} />
                        <Route path="/app/:accountId" render={() =>
                            <Account
                                user={user}
                                selectedAccount={selectedAccount}
                                handleConfigVisibleChange={this.handleConfigVisibleChange}
                                handleHelpVisibleChange={this.handleHelpVisibleChange}
                            />
                        } />


                    </Switch>
                </SplitPane>
                {this.props.videoDetails && this.props.videoDetails ?
                    <Draggable >
                        <div style={{ zIndex: 999999, position: "absolute", width: !this.state.width ? "400px" : "300px", bottom: "4px", left: "80px" }}>
                            <Card className="bg-white cursor-all-scroll" style={{ width: !this.state.width ? "400px" : "300px" }}  >
                                <Card.Content style={{ padding: "5px 0px 10px 0" }}>
                                    <Icon className="float-right cursor-pointer" name="close" onClick={this.closePlayer} />
                                    {this.props.videoDetails.path ?
                                        <React.Fragment>
                                            <Icon className="float-right cursor-pointer" name="expand arrows alternate" onClick={this.handleClickFullscreen} />
                                            <Icon className="float-right cursor-pointer" name="expand" onClick={this.changeWidth} />
                                        </React.Fragment> : null
                                    }
                                </Card.Content>
                                <Card.Content className="pad_0">
                                    {this.props.videoDetails.path ?
                                        <ReactPlayer
                                            ref={this.ref}
                                            url={this.props.videoDetails.path}
                                            width={!this.state.width ? "400px" : "300px"}
                                            height={!this.state.width ? "225px" : "86px"}
                                            controls
                                        /> :
                                        <Image src={comingsoonlogo} />
                                    }
                                </Card.Content >
                                <Card.Content extra style={{ padding: "7px" }}>
                                    <strong>{this.props.videoDetails.name}</strong>
                                </Card.Content>
                            </Card>
                        </div>
                    </Draggable> : null
                }
            </div>
        );
    }
}


function mapStateToProps(state) {

    const { user, selectedOrganisation, selectedAccount, organizations, helpContent, playbookPath, contentPath, userCache } = state.app;
    const { allAccounts } = state.account;
    const { allNotification } = state.notifications;
    const { accessToken, version } = state.login;
    const { videoDetails } = state.help;


    return {
        user,
        selectedOrganisation,
        selectedAccount,
        allAccounts,
        allNotification,
        accessToken,
        organizations,
        videoDetails,
        loadingNotifications: state.loading.effects.notifications.getNotifications && state.loading.models.notifications,
        version,
        notificationsCount: state.notifications.notificationsCount,
        helpContent,
        filterQuery: state.notifications.filterQuery,
        playbookPath,
        contentPath,
        userCache,
        isCopyActivityModalOpen: state.initiatives.isCopyActivityModalOpen,
    };
}

const connectedHomePage = withRouter(connect(mapStateToProps)(Home));
export { connectedHomePage as Home }; 
